import { Button } from 'components/ui/button';
import { useAccount } from 'frontastic/hooks';
import { useCart, useWishlist } from 'frontastic/hooks';
import { gtmAddToWishlist } from 'helpers/utils/gtm-events/gtmEccomerce';
import { LineItemMapper } from 'helpers/utils/gtm-events/mapper/LineItemMapper';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import toast from 'react-hot-toast';
import { Product, Variant } from 'shared/types/product';

type AddToMyListBtnProps = {
  product?: Product;
  variant?: Variant;
  quantity?: number;
};

function AddToMyListBtn({ product, quantity, variant }: AddToMyListBtnProps) {
  const { account } = useAccount();
  const { addToWishlist } = useWishlist();
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const { data: cart } = useCart();

  async function handleAddToWishlist() {
    if (account && variant?.sku && quantity) {
      try {
        await addToWishlist(variant.sku, quantity);
        toast.success('Item Added');

        if (product) {
          gtmAddToWishlist({
            itemDataLayer: LineItemMapper.fromProductToItemDataLayer(product, quantity, variant),
            quantity,
            cart,
            account,
          });
        }
      } catch (e) {
        toast.error((e as Error)?.message);
      }
    }
    if (!account && variant && variant.sku) {
      const newSearchParams = new URLSearchParams();

      newSearchParams.set('redirect', pathname);

      searchParams.forEach((value, key) => {
        newSearchParams.set(key, value);
      });

      newSearchParams.set('sku', variant.sku);

      newSearchParams.set('addToWishList', 'true');

      router.push(`/login?${newSearchParams.toString()}`);
    }
  }

  return (
    <Button
      aria-label="Add to My List"
      onClick={handleAddToWishlist}
      className="text-left text-sm font-semibold leading-[17px] text-[#222] hover:underline disabled:cursor-not-allowed disabled:no-underline disabled:opacity-50"
    >
      + Add to my List
    </Button>
  );
}

export default AddToMyListBtn;
